import i18n from '@/i18n';
import { CommunicationLanguage } from './communication-language.interface';
import { CommunicationLanguageService } from './communication-language.service';

const service = new CommunicationLanguageService();

export interface CommunicationLanguageState {
   communicationLanguages: CommunicationLanguage[];
   languages: Array<{ id: string; name: string }>;
}

const state: CommunicationLanguageState = {
   communicationLanguages: [],
   languages: [
      { id: 'nl', name: i18n.global.t('settings.languages.dutch') },
      { id: 'fr', name: i18n.global.t('settings.languages.french') },
      { id: 'en', name: i18n.global.t('settings.languages.english') },
   ],
};

const getters = {
   communicationLanguages(state: any) {
      return state.communicationLanguages;
   },
};

const mutations = {
   SET_COMMUNICATION_LANGUAGE(state: any, communicationLanguages: Array<CommunicationLanguage>) {
      state.communicationLanguages = communicationLanguages.map((cl) => ({ ...cl, key: cl.iso_639_1.toLowerCase() }));
   },
};

const actions = {
   async getCommunicationLanguages(context: any) {
      return await service.getCommunicationLanguages().then((response) => {
         context.commit('SET_COMMUNICATION_LANGUAGE', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
